import { Stack, styled } from '@mui/material';

import { Section } from '@rumblefish/ui/src/components/Rumblefish23Theme';

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  alignItems: 'center',
  gap: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(4),
  },
}));

export const SectionNameBannerStack = styled(Stack)({
  width: '100%',
});

export const StyledLinkWrapper = styled(Stack)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: theme.spacing(2, 0),
}));
